import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import Icon, { ICON_TYPE } from "components/Icon";
import { colors } from "style";

export const STATUS_ICON_VARIANT = {
  complete: "complete",
  error: "error",
  warning: "warning",
  active: "active",
};

const VARIANT_CONFIG = {
  [STATUS_ICON_VARIANT.complete]: { background: colors.green, type: ICON_TYPE.checkmark },
  [STATUS_ICON_VARIANT.error]: { background: colors.red, type: ICON_TYPE.close },
  [STATUS_ICON_VARIANT.warning]: { background: colors.warning, type: ICON_TYPE.checkmark },
  [STATUS_ICON_VARIANT.active]: { background: colors.white, ring: colors.green, color: colors.green },
};

/**
 * Progress Icon
 *
 * @params {String}   type        Icon shown when the variant does not set its own
 * @params {String}   color       Icon color when no variant applies
 * @params {String}   variant     One of STATUS_ICON_VARIANT; takes precedence over the boolean flags
 * @params {bool}     isComplete  Shorthand for the complete variant
 * @params {bool}     isError     Shorthand for the error variant
 */
const StatusIcon = ({ type = ICON_TYPE.checkmark, color, variant, isComplete, isError, ...props }) => {
  const config =
    VARIANT_CONFIG[variant || (isComplete && STATUS_ICON_VARIANT.complete) || (isError && STATUS_ICON_VARIANT.error)];

  return (
    <div css={styles.icon_container(config?.background, config?.ring)}>
      <Icon type={config?.type || type} color={config ? config.color || `#fff` : color} {...props} />
    </div>
  );
};

const styles = {
  icon_container: (background = colors.grayAnatomyLight5, ring) => css`
    background: ${background};
    box-shadow: ${ring ? `inset 0 0 0 2px ${ring}` : `none`};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    position: relative;
    width: 100%;
    height: 100%;
  `,
};

StatusIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(STATUS_ICON_VARIANT)),
  isComplete: PropTypes.bool,
  isError: PropTypes.bool,
};

export default StatusIcon;
